import { Stack } from '@mui/material';
import { styled } from 'styled-components';

import devices from '../../../../styles/devices';

type WrapperProps = {
  'data-is-empty'?: boolean;
};

export const EmptyText = styled.div`
  text-align: center;
  width: var(--preference-compose-dropdown-width-mobile);

  @media ${devices.tabletS} {
    width: var(--preference-compose-dropdown-width-desktop);
  }
`;

export const Wrapper = styled(Stack)<WrapperProps>`
  width: var(--preference-compose-dropdown-width-mobile);

  @media ${devices.tabletS} {
    max-height: var(--preference-compose-dropdown-height-desktop);
    padding: var(--spacing-medium);
    width: var(--preference-compose-dropdown-width-desktop);
  }

  ${({ 'data-is-empty': isEmpty }) =>
    isEmpty &&
    `
      align-items: center;
      justify-content: center;
      min-height: calc(var(--preference-compose-dropdown-width-mobile) / 2);

      @media ${devices.tabletS} {
        min-height: calc(var(--preference-compose-dropdown-width-desktop) / 2);
      }
  `}
`;
